import Component from 'component';
import slick from '../../core/slick'; //Using modified slick
import 'jquery.dotdotdot';
import Player from '@vimeo/player';

class FeaturedContentCarousel extends Component{
  constructor(el, config){
    super(el);

    this.init();
  }

  setupDefaults(){
    this.dom = {
      $list: this.$el.find('.featured-content-carousel__list--main'),
      $slides: this.$el.find('.featured-content-carousel-item'),
      $title: this.$el.find('.featured-content-carousel-item__title'),
      $listSub: this.$el.find('.featured-content-carousel__list--sub'),
      $slidesSub: this.$el.find('.featured-content-carousel-item__desc'),
      $dots: this.$el.find('.featured-content-carousel__dots'),
      $dot: this.$el.find('.featured-content-carousel__dots li'),
      $videoCovers: this.$el.find('.featured-content-carousel-item_image-overlay'),
      $cursor: this.$el.find('.featured-content-carousel__cursor'),
      $window: $(window)
    };
  }

  addListeners(){
    this.dom.$dot.on('click touch', ::this.onGoToSlide);
    this.dom.$videoCovers.on('click', ::this.removeVideoCover);
    this.$el.on('mousemove', '.featured-content-carousel__list--main .slick-slide', ::this.onMouseMove);
    this.$el.on('mouseenter', '.featured-content-carousel__list--main .slick-slide', ::this.onMouseEnter);
    this.$el.on('mouseleave', '.featured-content-carousel__list--main .slick-slide', ::this.onMouseLeave);
  }

  init() {
    if (this.dom.$slides.length < 2) {
      this.dom.$slides.find('.featured-content-carousel-item__media').addClass('pointer-events-all');
      this.dom.$list.addClass('full-width');
      return;
    }

    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      this.$el.addClass('is-mobile');
    }

    if (this.dom.$slides.length > 1) {
      this.dom.$dots.css('display', 'flex');
      this.duplicateSlides();
    }

    this.dom.$list.on('init', ::this.onSlickInit);
    this.dom.$list.slick({
      infinite: true,
      centerMode:  true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      focusOnSelect: true,
      centerPadding: '0px',
      asNavFor: this.dom.$listSub,
      dots: false,
      initialSlide: 1,
      autoplay: this.$el.data('autoplay'),
      autoplaySpeed: this.$el.data('autoplay-speed')
    }).on('beforeChange', ::this.onSlideChange)

    this.dom.$listSub.slick({
      infinite: true,
      slidesToShow: 1,
      arrows: false,
      asNavFor: this.dom.$list,
      fade: true,
      cssEase: 'linear',
      initialSlide: 1,
      autoplay: this.$el.data('autoplay'),
      autoplaySpeed: this.$el.data('autoplay-speed')
    });

    this.dom.$title.dotdotdot({
      watch: 'window'
    })
  }

  removeVideoCover(el) {
    this.setAutoplayToIframe(el)
    $(el.currentTarget).hide();
  }

  setAutoplayToIframe(el) {
    const iframe = el.currentTarget.parentElement.querySelector('iframe');
    const parameter = '&autoplay=1';

    if (iframe) {
      iframe.src.replace(parameter, '');
      iframe.src = `${iframe.src}${parameter}`
    }
  }

  duplicateSlides() {
    const $newSlides = this.dom.$slides.clone();

    //Have to do this becuase there is an issue with brightcove video player and cloning the slide
    $newSlides.each((index, element) => {
      if ($(element).hasClass('featured-content-carousel-item--video')) {
        const videoTag = $(element).find('video');
        const videoCover = $(element).find('.featured-content-carousel-item_image-overlay');
        const videoId = videoTag.data('video-id');
        const player = videoTag.data('player');
        const account = videoTag.data('account');

        let newVideo='';

        if (videoId === undefined){
          const iframeTag = $(element).find('iframe');
          const iframeSrc = iframeTag.attr('src')
          newVideo = `<iframe src="${iframeSrc}" class="iframe-vimeo" allow="autoplay; fullscreen; picture-in-picture"></iframe>`
        } else {
          newVideo = `<video data-account="${account}" data-video-id="${videoId}" id="wh-player-${new Date().getTime()}" data-player="${player}"
          data-embed="default" data-application-id class="video-js" controls></video><script src="//players.brightcove.net/${account}/${player}_default/index.min.js"></script>`;
        }
        $(element).find('.video-js').remove();
        $(element).find('.featured-content-carousel-item__media').html(videoCover[0].outerHTML + newVideo)
      }
    });
    this.dom.$list.append($newSlides);

    $newSlides.find('.featured-content-carousel-item_image-overlay').on('click', ::this.removeVideoCover);
    const $newSubSlides = this.dom.$slidesSub.clone();
    this.dom.$listSub.append($newSubSlides);
  }

  onSlickInit(event, slick) {
    if (slick.slideCount < 2) {
      $(slick.$slideTrack).addClass('full-width');
      return;
    }
  }

  onSlideChange(event, slick, currentSlide, nextSlide) {
    const $slide = $(slick.$slides[currentSlide]);
    const $nextSlide = $(slick.$slides[nextSlide]);
    const $vimeoIframe = $slide.find('iframe');

    $slide.find('.featured-content-carousel-item__media').addClass('pointer-events-none');

    $nextSlide.find('.featured-content-carousel-item__media').addClass('pointer-events-all').removeClass('pointer-events-none');

    if (currentSlide === nextSlide) {
      return;
    }

    if ($vimeoIframe.length > 0) {
      const player = new Player($vimeoIframe);
      player.pause();
    }

    if (window.videojs) {
      if ($slide.find('.video-js').length) {
        const pl = window.videojs($slide.find('.video-js video').attr('id'));
        pl.pause();
      }
    }

    this.dom.$dot.removeClass('active')
    if (nextSlide < this.dom.$slides.length) {
      this.dom.$dots.find(`li[data-dot=${nextSlide}]`).addClass('active')
    } else {
      this.dom.$dots.find(`li[data-dot=${nextSlide - this.dom.$slides.length}]`).addClass('active')
    }
  }


  onGoToSlide(e) {
    const $current = $(e.currentTarget);
    this.dom.$dot.removeClass('active')
    $current.addClass('active')
    if (this.dom.$list.slick('slickCurrentSlide') < this.dom.$slides.length) {
      this.dom.$list.slick('slickGoTo', $current.data('dot'));
    } else {
      this.dom.$list.slick('slickGoTo', $current.data('dot') + this.dom.$slides.length);
    }
  }

  onMouseMove(e) {
    if (e.currentTarget.classList.contains('slick-current')) {
      return;
    }

    if (this.dom.$window.width() < 1024) {
      return;
    }

    const el = e.currentTarget;
    let xPos = 0,
    yPos = 0;

    xPos = (el.offsetLeft - el.scrollLeft + el.clientLeft);
    yPos = (el.offsetTop - el.scrollTop + el.clientTop);
    const mouseX = e.clientX;
    const mouseY = e.clientY - yPos;

    if (mouseX < window.innerWidth / 2) {
      this.dom.$cursor.addClass('right');
    } else {
      this.dom.$cursor.removeClass('right');
    }

    this.dom.$cursor.css({
      top: e.pageY-this.$el.offset().top,
      left: mouseX
    });
  }

  onMouseEnter(e) {
    if (e.currentTarget.classList.contains('slick-current')) {
      return;
    }

    if (this.dom.$window.width() < 1024) {
      return;
    }
    this.dom.$cursor.show();
  }

  onMouseLeave(e) {
    if (e.currentTarget.classList.contains('slick-current')) {
      return;
    }

    if (this.dom.$window.width() < 1024) {
      return;
    }
    this.dom.$cursor.hide();
  }
}

export default FeaturedContentCarousel;



// WEBPACK FOOTER //
// ./src/js/components/careers/FeaturedContentCarousel.js